import { SubscriptionSource } from "../../../../../../types"
import { capitalize } from "../../../../../utils"
import Badge from "../../../../badge"

interface EngagementsBadgesProps {
  source: SubscriptionSource
}

const badgeTypes = {
  engagement: Badge.Info,
  embed: Badge.Success,
  log: Badge.Danger,
  unknown: Badge.Disabled,
  bb_sms: Badge.Alt
}

const EngagementsBadges = ({ source }: EngagementsBadgesProps) => {
  const BadgeComponent = badgeTypes[source] || Badge.Info // Use a default or fallback component

  return (
    <BadgeComponent>
      {source === "bb_sms" ? "SMS" : capitalize(source)}
    </BadgeComponent>
  )
}

export default EngagementsBadges
